module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr name=\"record-")
    ; __append(escapeFn( record.index ))
    ; __append("\" class=\"record\">\n    <td></td>\n    <td style=\"vertical-align: top\">\n        <control index=\"")
    ; __append(escapeFn( record.index ))
    ; __append("\" type=\"text\" html-name=\"key\" html-placeholder=\"Введите уникальный индекс значения\" target=\"item.records[")
    ; __append(escapeFn( record.index ))
    ; __append("].key\"/>\n    </td>\n    <td>\n        <control index=\"")
    ; __append(escapeFn( record.index ))
    ; __append("\" type=\"text-area\" html-name=\"value\" html-placeholder=\"Введите значение записи\" target=\"item.records[")
    ; __append(escapeFn( record.index ))
    ; __append("].value\"/>\n    </td>\n</tr>\n")
  }
  return __output.join("");

}